export enum TrackingStep {
    Calculator = 'Calculator',
    MainApplicantInfo = 'MainApplicantInfo',
    MainApplicantKyc = 'MainApplicantKyc',
    SendApplication = 'SendApplication',
    LoanInfo = 'LoanInfo',
    Sbl = 'Sbl',
    OngoingApplications = 'OngoingApplications',
    BillanSoknadGodkjent = 'BillanSoknadGodkjent',
    BillanSoknadManuellKontroll = 'BillanSoknadManuellKontroll',
    BillanSoknadAvslag = 'BillanSoknadAvslag',
    EuroTax = 'EuroTax',
    CompletionStart = 'CompletionStart',
    CompletionSbl = 'CompletionSbl',
    CompletionInsurance = 'CompletionInsurance',
    CompletionDetails = 'CompletionDetails',
    CompletionKyc = 'CompletionKyc',
    CompletionSigning = 'CompletionSigning',
    CompletionReceipt = 'CompletionReceipt',
    CompletionReceiptInsuranceCard = 'CompletionReceiptInsuranceCard',
    CompletionReceiptInsuranceCardClick = 'CompletionReceiptInsuranceCardClick',
    BillanSoknadProfitabilityHigh = 'BillanSoknadProfitabilityHigh',
    BillanSoknadProfitabilityMedium = 'BillanSoknadProfitabilityMedium',
    BillanSoknadProfitabilityLow = 'BillanSoknadProfitabilityLow',
    BillanSoknadProfitabilityMissing = 'BillanSoknadProfitabilityMissing',
}

export const trackEvent = (trackingStep: TrackingStep) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'virtual-page-view',
        virtual_path: trackingStep,
        app_namespace: 'kredittbank.securedloan.application.web',
    });
};
